import { render, staticRenderFns } from "./InterimOrder.vue?vue&type=template&id=d864a518"
import script from "./InterimOrder.vue?vue&type=script&lang=ts"
export * from "./InterimOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports